import type { DropDownOption } from "../components/DropDownMenu";

export const rangeSelector = (
  base: { option: string; label: string }[],
  customOnClick?: (index: number, option: string) => void
): DropDownOption[] => {
  return base.map(({ option, label }, index) => ({
    option,
    label,
    onClick: () => customOnClick?.(index, option),
  }));
};
